import { toInteger } from 'lodash';
import SmiConstants from 'sg-smi-constants';

const SMI_TAGGING_PROPERTIES = {
    hadCancerLastFiveYears: { id: 'hasHadCancer' },
    pageType: { id: 'pageType' },
    hasPrivateHealthInsurance: {
        id: 'privateHealthInsuranceOwnership',
        transform: (value) => {
            return value ? 'yes' : 'no';
        }
    },
    additionalPolicyholderNumber: {
        id: 'additionalPolicyholderNumber',
        transform: (value) => toInteger(value.length - 1)
    },
    addedPartnerToPolicy: {
        id: 'addedPartnerToPolicy',
        transform: (value) => {
            return value ? 'yes' : 'no';
        }
    },
    excess: {
        id: 'excess',
        transform: (value) => {
            return value.substring(value.indexOf('_') + 1);
        }
    },
    fourWeekWait: {
        id: 'fourWeekWait',
        transform: (value) => {
            return value ? 'yes' : 'no';
        }
    },
    selectedPlan: {
        id: 'selectedPlan',
        transform: (value) => {
            return SmiConstants.PRODUCT_NAMES[value];
        }
    },
    selectedHospitalOption: {
        id: 'selectedHospitalOption',
        transform: (value) => {
            return SmiConstants.HOSPITAL_OPTION_NAMES[value];
        }
    },
    saverPlusMonthlyPrice: {
        id: 'saverPlusMonthlyPrice',
        transform: (value) => {
            return value.toString();
        }
    },
    secureMonthlyPrice: {
        id: 'secureMonthlyPrice',
        transform: (value) => {
            return value.toString();
        }
    },
    superMonthlyPrice: {
        id: 'superMonthlyPrice',
        transform: (value) => {
            return value.toString();
        }
    },
    saverPlusQuarterlyPrice: {
        id: 'saverPlusQuarterlyPrice',
        transform: (value) => {
            return value.toString();
        }
    },
    secureQuarterlyPrice: {
        id: 'secureQuarterlyPrice',
        transform: (value) => {
            return value.toString();
        }
    },
    superQuarterlyPrice: {
        id: 'superQuarterlyPrice',
        transform: (value) => {
            return value.toString();
        }
    },
    cancerCoverAddon: {
        id: 'CancerCoverAddon',
        transform: (value) => {
            return value ? 'yes' : 'no';
        }
    },
    totalPremiumCost: {
        id: 'totalPremiumCost',
        transform: (value) => {
            return value.toString();
        }
    },
    priceDifference: {
        id: 'priceDifference'
    },
    addOnsPmi: {
        id: 'addOnsPmi'
    },
    removedAddOns: {
        id: 'removedAddOns'
    },
    paymentByInstalments: {
        id: 'paymentByInstalments',
        transform: (value) => {
            return value ? 'yes' : 'no';
        }
    },
    hypertensionCoverAddon: {
        id: 'HypertensionCoverAddOn',
        transform: (value) => {
            return value ? 'yes' : 'no';
        }
    },
    hasDiabetesStrokeHeartDisease: {
        id: 'HasDiabetesStrokeHeartDisease',
        transform: (value) => {
            return value ? 'yes' : 'no';
        }
    },
    hasHypertensionBeenControlled: {
        id: 'hasHypertensionBeenControlled',
        transform: (value) => {
            return value ? 'yes' : 'no';
        }
    },
    stickyBannerCost: {
        id: 'stickyBannerCost',
        transform: (value) => {
            return value.toString();
        }
    },
    quarterlyPayment: {
        id: 'quarterlyPayment',
        transform: (value) => {
            return value ? 'yes' : undefined;
        }
    },
    quarterlyInstalmentValue: {
        id: 'quarterlyInstalmentValue'
    },
};

export default SMI_TAGGING_PROPERTIES;
